import { loadGoogleSdk as e } from "./loadGoogleSdk.mjs";
//#region src/web/sdk/googleButton.ts
var t = (e) => Math.max(200, Math.min(400, e || 360));
async function n(n) {
	let r = await e(), i = crypto.randomUUID();
	return r.initialize({
		client_id: n.clientId,
		nonce: i,
		use_fedcm_for_prompt: !0,
		callback: (e) => {
			e.credential ? n.onCredential(e.credential, i) : n.onError?.(/* @__PURE__ */ Error("Google sign-in returned no credential"));
		}
	}), r.renderButton(n.container, {
		type: "standard",
		theme: "outline",
		size: "large",
		text: "continue_with",
		shape: "pill",
		logo_alignment: "center",
		width: t(n.container.offsetWidth)
	}), n.autoPrompt && r.prompt(), r;
}
//#endregion
export { n as setupGoogleButton };
